import React from 'react'
import {
    Grid
} from '@mui/material'
import HomeServiceTable from '../../Components/Tables/HomeServiceTable/HomeServiceTable'

export default function HomeServiceRecords() {
  return (
    <Grid container style={{height:'100%'}}>

    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <HomeServiceTable/>    
    </Grid>

</Grid>
  )
}
